import React from 'react';
import { Col, Row } from 'react-bootstrap';
import AcompanhamentosCard from '@/containers/Acompanhamentos/Listagem/components/AcompanhamentosCard';

const AcompanhamentosTab = ({ depotId }) => {
  return (
    <Row>
      <Col md={12}>
        <AcompanhamentosCard
          depotId={depotId}
          showActions={false}
          enableRowClick={true}
          showFilter={false}
          showHeader={false}
        />
      </Col>
    </Row>
  );
};

export default AcompanhamentosTab;
